<template>
  <footer class="spartan-footer">
    <div class="secondary-logo">
      <!-- <router-link :to="www.shield-maintenance.com/shield">
        <img
          src="../assets/shield-logo-web-reversed.svg"
          alt="Shield Maintenance"
        />
      </router-link>
      <router-view /> -->
      <a href="#" @click.prevent="goToShield">
        <img
          src="../assets/shield-logo-web-reversed.svg"
          alt="Shield Maintenance"
        />
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SpartanFooter",
  methods: {
    goToShield: function(){
      // console.log('go to shield website');
      window.location.href="http://shield-maintenance.com/shield";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";

.spartan-footer {
  background: #7a7a75;
  padding-top: 1em;
  padding-bottom: 0.5em;

  @media screen and (min-width: $medium-bp+0.1) {
    display: flex;
    justify-content: flex-end;
  }

  .secondary-logo {
    @media screen and (max-width: $medium-bp) {
      width: 70%;
      margin: auto;
    }

    @media screen and (min-width: $medium-bp+0.1) {
      width: 25%;
      margin-right: 5%;
    }
  }
}
</style>
